import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { LsqBrowserNotSupportedPageComponent } from './components/pages/browser-not-supported/lsq-browser-not-supported.component';
import { LsqHealthComponent } from './components/pages/health/lsq-health.component';
import { LsqLogoutComponent } from './components/pages/logout/lsq-logout.component';
import { LsqToastComponent } from './components/toast/lsq-toast.component';
import { LsqCoreModule } from './core';
import { LsqFormsModule } from './forms';
import { LsqModalsModule } from './modals';

export { LsqBrowserNotSupportedPageComponent, LsqHealthComponent, LsqLogoutComponent };

@NgModule({
    imports: [
        LsqCoreModule.forRoot(),
        LsqModalsModule,
        LsqFormsModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            toastComponent: LsqToastComponent,
            easeTime: 150,
            preventDuplicates: true,
            closeButton: true,
            progressBar: true,
            autoDismiss: true,
            maxOpened: 1 // we only have one generic error so no need to show multiple times
        })
    ],
    declarations: [LsqBrowserNotSupportedPageComponent, LsqLogoutComponent],
    exports: [LsqCoreModule, LsqModalsModule, LsqFormsModule, BrowserAnimationsModule, ToastrModule]
})
export class LsqAppRootModule {
    constructor() {
        console.debug('Loading libs/LsqAppRootModule.');
    }
}
